import React from 'react';
import styles from './index.module.scss';

const Checkbox = (props) => {
  const { title, isChecked, setIsChecked, customClass = '' } = props;

  return (
    <div className={`${styles['checkbox-group']} ${customClass}`}>
      <div className={styles['checkbox-label']}>{title}</div>
      <input
        type={'checkbox'}
        className={'form-control'}
        checked={isChecked}
        onChange={(e) => setIsChecked(e.target.checked)}
      />
    </div>
  );
};

export default Checkbox;
